import Swiper from 'swiper';
import { Navigation } from 'swiper/modules';
import 'swiper/css';

export class Process {
  constructor() {
    this.initRelationSwiper();
  }

  initRelationSwiper() {
    const relationSwiper = document.querySelector('.relation-swiper');

    if (!relationSwiper) return;

    // Initialize Swiper for mobile version only
    new Swiper('.relation-swiper', {
      modules: [Navigation],
      slidesPerView: 'auto',
      centeredSlides: true,
      spaceBetween: 34,
      navigation: {
        nextEl: '.relation-nav-next',
        prevEl: '.relation-nav-prev',
      }
    });
  }
}
